import AuthActionTypes from './auth.types';

/*************************************************/

const INITIAL_STATE = {
  token: localStorage.getItem("access") || null,
  error: "",
  loading: false,
  admin_data: null,
};

/*************************************************/

const userReducer = (state = INITIAL_STATE, action = {}) => {
  
    switch (action.type) {
      case AuthActionTypes.SIGN_IN_SUCCESS:
        const newToken = localStorage.getItem("access");
      
        return {
          ...state,
          admin_data: action.payload?.user || action.payload,
          token: newToken,
        };
      case AuthActionTypes.SIGN_OUT_SUCCESS:
      
        return {
          ...INITIAL_STATE,
          admin_data: null,
          token: null,
        };
      case AuthActionTypes.REGISTER_SUCCESS:
        return {
          ...state,
          loading: false,
        };
      case AuthActionTypes.REGISTER_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case AuthActionTypes.REGISTER_INITIATE_SUCCESS:
        return {
          ...state,
          loading: false,
        };
      case AuthActionTypes.REGISTER_INITIATE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case AuthActionTypes.REGISTER_COMPLETE_SUCCESS:
        const completeToken = localStorage.getItem("access");
        return {
          ...state,
          loading: false,
          admin_data: action.payload?.user || null,
          token: completeToken,
        };
      case AuthActionTypes.REGISTER_COMPLETE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case AuthActionTypes.RESET_AUTH_STATE:
        return {
          ...INITIAL_STATE,
          token: null,
        };
      case AuthActionTypes.LOADING_START:
        return {
          ...state,
          loading: true,
        };
      case AuthActionTypes.LOADING_STOP:
        return {
          ...state,
          loading: false,
        };
   
     
      default:
        return state;
    }
}

/*************************************************/

export default userReducer;

/*************************************************/
